/** Scratch 编程题（与后端 ScratchQuestionService 对齐） */

export const SCRATCH_TYPE = 'scratch'
export const SCRATCH_MAX_BYTES = 10 * 1024 * 1024

export function parseScratchAnswer(raw) {
  if (raw == null) {
    return { storageName: '', originalName: '', size: 0, downloadUrl: '', viewUrl: '', publicProjectUrl: '', teacherComment: '' }
  }
  if (typeof raw === 'object' && !Array.isArray(raw)) {
    return {
      storageName: String(raw.storageName || ''),
      originalName: String(raw.originalName || ''),
      size: Number(raw.size) || 0,
      downloadUrl: String(raw.downloadUrl || ''),
      viewUrl: String(raw.viewUrl || ''),
      publicProjectUrl: String(raw.publicProjectUrl || ''),
      teacherComment: String(raw.teacherComment || '')
    }
  }
  const s = String(raw || '').trim()
  if (!s) {
    return { storageName: '', originalName: '', size: 0, downloadUrl: '', viewUrl: '', publicProjectUrl: '', teacherComment: '' }
  }
  try {
    const o = JSON.parse(s)
    if (o && typeof o === 'object') {
      return parseScratchAnswer(o)
    }
  } catch (e) {
    void e
  }
  return { storageName: '', originalName: '', size: 0, downloadUrl: '', viewUrl: '', publicProjectUrl: '', teacherComment: '' }
}

export function stringifyScratchAnswer(draft) {
  const d = draft && typeof draft === 'object' ? draft : {}
  return JSON.stringify({
    storageName: d.storageName != null ? String(d.storageName) : '',
    originalName: d.originalName != null ? String(d.originalName) : '',
    size: Number(d.size) || 0,
    downloadUrl: d.downloadUrl != null ? String(d.downloadUrl) : '',
    viewUrl: d.viewUrl != null ? String(d.viewUrl) : '',
    publicProjectUrl: d.publicProjectUrl != null ? String(d.publicProjectUrl) : '',
    teacherComment: d.teacherComment != null ? String(d.teacherComment) : ''
  })
}

export function isScratchAnswerComplete(raw) {
  const a = parseScratchAnswer(raw)
  return !!(a.storageName && a.downloadUrl)
}

export function scratchSubmitBlockedMessage() {
  return '请先完成 Scratch 作品并上传 .sb3 项目后再交卷（单个文件不超过 10MB）。'
}

export function defaultScratchOptions() {
  return {
    allowNewSprites: true,
    allowNewBackdrops: true,
    allowMaterialsLibrary: true,
    emptyProjectDefault: true
  }
}
